export default {
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [// 供应商管理-企业信息管理-供应商准入
  {
    path: 'supAdmittanceManage',
    name: 'supAdmittanceManage',
    meta: {
      title: '供应商准入',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supAdmittanceManage']
    },
    component: function component() {
      return import('@/pages/supplierModule/supEnterpriseInfoMenu/supAdmittanceManage/supAdmittanceManage');
    }
  }, // 供应商管理-失信行为管理-供应商申诉
  {
    path: 'supDishonestyList',
    name: 'supDishonestyList',
    meta: {
      title: '供应商申诉',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supDishonestyList']
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/supDishonestyList/supDishonestyList');
    }
  }, // 供应商管理-失信行为管理-采购商失信行为记录
  {
    path: 'purDishonestyList',
    name: 'purDishonestyList',
    meta: {
      title: '失信行为记录',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['purDishonestyList']
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/purDishonestyList/purDishonestyList');
    }
  }, // 供应商管理-失信行为管理-运营失信行为管理
  {
    path: 'opeDishonestyManageList',
    name: 'opeDishonestyManageList',
    meta: {
      title: '失信行为管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['opeDishonestyManageList']
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/opeDishonestyManageList/opeDishonestyManageList');
    }
  }, // 供应商管理-失信行为管理-运营失信行为申诉
  {
    path: 'opeDishonestyAppealList',
    name: 'opeDishonestyAppealList',
    meta: {
      title: '失信行为申诉管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['opeDishonestyAppealList']
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/opeDishonestyAppealList/opeDishonestyAppealList');
    }
  }, // 供应商管理-失信行为管理-运营黑名单
  {
    path: 'opeBlackList',
    name: 'opeBlackList',
    meta: {
      title: '黑名单管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['opeBlackList']
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/opeBlackList/opeBlackList');
    }
  }, // 供应商管理-企业信息管理-企业基本信息
  {
    path: 'enterpriseInfoManage',
    name: 'enterpriseInfoManage',
    meta: {
      title: '企业基本信息',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['enterpriseInfoManage']
    },
    component: function component() {
      return import('@/pages/supplierModule/supEnterpriseInfoMenu/enterpriseInfoManage/enterpriseInfoManage');
    }
  }, // 供应商管理-企业信息管理-企业信息变更
  {
    path: 'enterpriseInfoAdd',
    name: 'enterpriseInfoAdd',
    meta: {
      title: '企业基本信息变更',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supEnterpriseInfoMenu/enterpriseInfoManage/enterpriseInfoAdd');
    }
  }, // 供应商管理-企业信息管理-企业资质信息
  {
    path: 'qualificationsInfoManage',
    name: 'qualificationsInfoManage',
    meta: {
      title: '资质信息管理',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['qualificationsInfoManage']
    },
    component: function component() {
      return import('@/pages/supplierModule/supEnterpriseInfoMenu/qualificationsInfoManage/qualificationsInfoManage');
    }
  }, // 供应商管理-供应商审批-供应商准入审批
  {
    path: 'supAdmittanceApprovalList',
    name: 'supAdmittanceApprovalList',
    meta: {
      title: '供应商准入审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supAdmittanceApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supAdmittanceApprovalList/supAdmittanceApprovalList');
    }
  }, // 供应商管理-失信行为管理-失信行为审批
  {
    path: 'supDishonestyApprovalList',
    name: 'supDishonestyApprovalList',
    meta: {
      title: '失信行为审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supDishonestyApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supDishonestyApprovalList/supDishonestyApprovalList');
    }
  }, // 供应商管理-失信行为管理-评级审批
  {
    path: 'supGradeApprovalList',
    name: 'supGradeApprovalList',
    meta: {
      title: '评级审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supGradeApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supGradeApprovalList/supGradeApprovalList');
    }
  }, // 供应商管理-失信行为管理-定级审批
  {
    path: 'supGradingApplicationList',
    name: 'supGradingApplicationList',
    meta: {
      title: '定级审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supGradingApplicationList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supGradingApplicationList/supGradingApplicationList');
    }
  }, // 供应商管理-失信行为管理-信息变更审批
  {
    path: 'supInfoChangeApprovalList',
    name: 'supInfoChangeApprovalList',
    meta: {
      title: '信息变更审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supInfoChangeApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supInfoChangeApprovalList/supInfoChangeApprovalList');
    }
  }, // 供应商管理-失信行为管理-资质信息审批
  {
    path: 'supQualificationInfoApprovalList',
    name: 'supQualificationInfoApprovalList',
    meta: {
      title: '资质信息审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supQualificationInfoApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supQualificationInfoApprovalList/supQualificationInfoApprovalList');
    }
  }, // 供应商管理-统计查询-黑名单信息
  {
    path: 'supBlackInfoList',
    name: 'supBlackInfoList',
    meta: {
      title: '黑名单信息',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supBlackInfoList']
    },
    component: function component() {
      return import('@/pages/supplierModule/statisticalQueryMenu/supBlackInfoList/supBlackInfoList');
    }
  }, // 供应商管理-统计查询-失信行为记录
  {
    path: 'supDishonestyInfoList',
    name: 'supDishonestyInfoList',
    meta: {
      title: '失信行为记录',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supDishonestyInfoList']
    },
    component: function component() {
      return import('@/pages/supplierModule/statisticalQueryMenu/supDishonestyInfoList/supDishonestyInfoList');
    }
  }, // 供应商管理-统计查询-供应商画像
  {
    path: 'supImgList',
    name: 'supImgList',
    meta: {
      title: '供应商画像',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supImgList']
    },
    component: function component() {
      return import('@/pages/supplierModule/statisticalQueryMenu/supImgList/supImgList');
    }
  }, // 供应商管理-统计查询-供应商名录
  {
    path: 'supNameList',
    name: 'supNameList',
    meta: {
      title: '供应商名录',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supNameList']
    },
    component: function component() {
      return import('@/pages/supplierModule/statisticalQueryMenu/supNameList/supNameList');
    }
  }, // 供应商管理-统计查询-供应商排名
  {
    path: 'supRankingList',
    name: 'supRankingList',
    meta: {
      title: '供应商排名',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supRankingList']
    },
    component: function component() {
      return import('@/pages/supplierModule/statisticalQueryMenu/supRankingList/supRankingList');
    }
  }, // 供应商管理-整改管理-供应商整改情况落实
  {
    path: 'supRectificationFindList',
    name: 'supRectificationFindList',
    meta: {
      title: '整改情况落实',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supRectificationFindList']
    },
    component: function component() {
      return import('@/pages/supplierModule/rectificationManageMenu/supRectificationFindList/supRectificationFindList');
    }
  }, // 供应商管理-整改管理-供应商整改措施
  {
    path: 'supRectificationList',
    name: 'supRectificationList',
    meta: {
      title: '整改措施',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supRectificationList']
    },
    component: function component() {
      return import('@/pages/supplierModule/rectificationManageMenu/supRectificationList/supRectificationList');
    }
  }, // 供应商管理-评级管理-评级指标设置
  {
    path: 'supGradeIndexList',
    name: 'supGradeIndexList',
    meta: {
      title: '评级指标设置',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supGradeIndexList']
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supGradeIndexList/supGradeIndexList');
    }
  }, // 供应商管理-评级管理-定级申请
  {
    path: 'supGradingManage',
    name: 'supGradingManage',
    meta: {
      title: '定级申请',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supGradingManage']
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supGradingManage/supGradingManage');
    }
  }, // 供应商管理-评级管理-定级申请待审批
  {
    path: 'supApprovepen',
    name: 'supApprovepen',
    meta: {
      title: '定级申请待审批',
      cache: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supApprovepen/supApprovepen');
    }
  }, // 供应商管理-评级管理-定级申请驳回
  {
    path: 'supApprovepenDetail',
    name: 'supApprovepenDetail',
    meta: {
      title: '定级申请审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supApprovepen/supApprovepenDetail');
    }
  }, {
    path: 'supApprovere',
    name: 'supApprovere',
    meta: {
      title: '定级申请驳回',
      cache: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supApprovere/supApprovere');
    }
  }, {
    path: 'supApprovereDetail',
    name: 'supApprovereDetail',
    meta: {
      title: '定级申请审批驳回详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supApprovere/supApprovereDetail');
    }
  }, // 供应商管理-评级管理-定级申请通过
  {
    path: 'supApprovepa',
    name: 'supApprovepa',
    meta: {
      title: '定级申请通过',
      cache: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supApprovepa/supApprovepa');
    }
  }, {
    path: 'supApprovepaDetail',
    name: 'supApprovepaDetail',
    meta: {
      title: '定级申请审批详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supApprovepa/supApprovepaDetail');
    }
  }, // 供应商管理-评级管理-等级设置
  {
    path: 'supLevelSettingList',
    name: 'supLevelSettingList',
    meta: {
      title: '等级设置',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supLevelSettingList']
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supLevelSettingList/supLevelSettingList');
    }
  }, // 供应商管理-评级管理-评级上报
  {
    path: 'supRatingReportList',
    name: 'supRatingReportList',
    meta: {
      title: '评级上报',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supRatingReportList']
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supRatingReportList/supRatingReportList');
    }
  }, // 供应商管理-评级管理-供应商评级结果
  {
    path: 'supRatingResultsList',
    name: 'supRatingResultsList',
    meta: {
      title: '供应商评级结果',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supRatingResultsList']
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supRatingResultsList/supRatingResultsList');
    }
  }, // 供应商管理-评级管理-评级规则设置
  {
    path: 'supRatingRulesList',
    name: 'supRatingRulesList',
    meta: {
      title: '评级规则设置',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supRatingRulesList']
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supRatingRulesList/supRatingRulesList');
    }
  }, // 供应商管理-评级管理-供应商评分
  {
    path: 'supScoreList',
    name: 'supScoreList',
    meta: {
      title: '供应商评分',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supScoreList']
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supScoreList/supScoreList');
    }
  }, // 供应商管理-整改管理-评分小组设置
  {
    path: 'supScoringTeamList',
    name: 'supScoringTeamList',
    meta: {
      title: '评分小组设置',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supScoringTeamList']
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supScoringTeamList/supScoringTeamList');
    }
  }, // 供应商管理-企业信息管理-资质信息管理-资质详情
  {
    path: 'qualificationsDetail',
    name: 'qualificationsDetail',
    meta: {
      title: '资质详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supEnterpriseInfoMenu/qualificationsInfoManage/qualificationsDetail');
    }
  }, // 供应商管理-企业信息管理-资质信息管理-资质新增 / 修改
  {
    path: 'qualificationsEdit',
    name: 'qualificationsEdit',
    meta: {
      title: '资质新增/修改',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supEnterpriseInfoMenu/qualificationsInfoManage/qualificationsEdit');
    }
  }, // 供应商管理-统计查询-失信行为记录-录入信息
  {
    path: 'purDishonestyAddInfo',
    name: 'purDishonestyAddInfo',
    meta: {
      title: '录入信息',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/purDishonestyList/purDishonestyAddInfo');
    }
  }, // 供应商管理-统计查询-失信行为记录-查看详情
  {
    path: 'purDishonestyDetail',
    name: 'purDishonestyDetail',
    meta: {
      title: '失信行为记录详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/purDishonestyList/purDishonestyDetail');
    }
  }, // 供应商管理-统计查询-失信行为记录-黑名单管理(运)-添加黑名单
  {
    path: 'opeAddBlackList',
    name: 'opeAddBlackList',
    meta: {
      title: '添加黑名单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/opeBlackList/opeAddBlackList');
    }
  }, // 供应商管理-统计查询-失信行为记录-黑名单管理(运)-查看详情黑名单
  {
    path: 'opeBlackDetail',
    name: 'opeBlackDetail',
    meta: {
      title: '查看详情黑名单',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/opeBlackList/opeBlackDetail');
    }
  }, // 供应商管理-统计查询-失信行为记录--申诉详情
  {
    path: 'opeComplaintdetails',
    name: 'opeComplaintdetails',
    meta: {
      title: '申诉详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/opeDishonestyAppealList/opeComplaintdetails');
    }
  }, // 供应商管理-统计查询-失信行为记录--申诉处理
  {
    path: 'opeHandleRepresentations',
    name: 'opeHandleRepresentations',
    meta: {
      title: '失信行为处理',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/opeDishonestyManageList/opeHandleRepresentations');
    }
  }, // 供应商管理-统计查询-失信行为记录--查看申诉详情
  {
    path: 'opeSeeAppealDetail',
    name: 'opeSeeAppealDetail',
    meta: {
      title: '失信行为记录详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/opeDishonestyManageList/opeSeeAppealDetail');
    }
  }, // 供应商管理-统计查询-失信行为记录--供应商申诉
  {
    path: 'supDishonesty',
    name: 'supDishonesty',
    meta: {
      title: '申诉',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/supDishonestyList/supDishonesty');
    }
  }, // 供应商管理-统计查询-失信行为记录--供应商申诉详情
  {
    path: 'supDishonestyDetail',
    name: 'supDishonestyDetail',
    meta: {
      title: '申诉详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/dishonestyMenu/supDishonestyList/supDishonestyDetail');
    }
  }, // 供应商管理-统计查询-整改管理--整改要求
  {
    path: 'supRectificationDetail',
    name: 'supRectificationDetail',
    meta: {
      title: '整改要求',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/rectificationManageMenu/supRectificationFindList/supRectificationDetail');
    }
  }, // 供应商管理-统计查询-整改管理--确认方案
  {
    path: 'supConfirmationScheme',
    name: 'supConfirmationScheme',
    meta: {
      title: '确认方案',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/rectificationManageMenu/supRectificationFindList/supConfirmationScheme');
    }
  }, // 供应商管理-统计查询-整改管理--查看记录
  {
    path: 'supViewRecords',
    name: 'supViewRecords',
    meta: {
      title: '查看记录',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/rectificationManageMenu/supRectificationFindList/supViewRecords');
    }
  }, // 供应商管理-统计查询-整改管理--确认
  {
    path: 'supRectificationOk',
    name: 'supRectificationOk',
    meta: {
      title: '确认',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/rectificationManageMenu/supRectificationList/supRectificationOk');
    }
  }, // 供应商管理-统计查询-整改管理--提交方案
  {
    path: 'supRectificationSubmit',
    name: 'supRectificationSubmit',
    meta: {
      title: '提交方案',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/rectificationManageMenu/supRectificationList/supRectificationSubmit');
    }
  }, // 供应商管理-供应商审批-准入审批--供应商审批
  {
    path: 'supApproved',
    name: 'supApproved',
    meta: {
      title: '供应商审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supAdmittanceApprovalList/supApproved');
    }
  }, // 供应商管理-供应商审批-准入审批--供应商变更审批审批
  {
    path: 'supChangeApproved',
    name: 'supChangeApproved',
    meta: {
      title: '供应商变更审批审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supInfoChangeApprovalList/supChangeApproved');
    }
  }, // 供应商管理-供应商审批-准入审批--供应商定级申请审批
  {
    path: 'supGradingApplicationListDetail',
    name: 'supGradingApplicationListDetail',
    meta: {
      title: '供应商定级申请审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supGradingApplicationList/supGradingApplicationListDetail');
    }
  }, // 供应商管理-供应商审批-准入审批--资质信息审批
  {
    path: 'supQualificationInfoApprovalDetail',
    name: 'supQualificationInfoApprovalDetail',
    meta: {
      title: '资质信息审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supQualificationInfoApprovalList/supQualificationInfoApprovalDetail');
    }
  }, // 供应商管理-供应商审批-准入审批--失信行为审批
  {
    path: 'supDishonestyApprovalDetail',
    name: 'supDishonestyApprovalDetail',
    meta: {
      title: '失信行为审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supDishonestyApprovalList/supDishonestyApprovalDetail');
    }
  }, // 供应商管理-供应商评级管理-供应商评分--供应商评分
  {
    path: 'supScoreDetail',
    name: 'supScoreDetail',
    meta: {
      title: '供应商评分',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supScoreList/supScoreDetail');
    }
  }, // 供应商管理-供应商评级管理-供应商评级--供应商评级上报
  {
    path: 'supRatingReportDetail',
    name: 'supRatingReportDetail',
    meta: {
      title: '供应商评级上报',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supRatingReportList/supRatingReportDetail');
    }
  }, // 供应商管理-供应商评级管理-供应商评级--供应商评级历史
  {
    path: 'supRatingHistory',
    name: 'supRatingHistory',
    meta: {
      title: '供应商评级历史',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supRatingResultsList/supRatingHistory');
    }
  }, // 供应商管理-供应商评级管理-供应商评级--评级规则设置
  {
    path: 'supRatingRulesDetail',
    name: 'supRatingRulesDetail',
    meta: {
      title: '评级规则设置',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supRatingRulesList/supRatingRulesDetail');
    }
  }, // 供应商管理-统计查询-供应商排名--供应商信息表
  // {
  //   path: 'supRankingDetail',
  //   name: 'supRankingDetail',
  //   meta: {
  //     title: '供应商信息表',
  //     hidden: true
  //   },
  //   component: () => import('@/pages/supplierModule/statisticalQueryMenu/supRankingList/supRankingDetail')
  // },
  // 供应商管理-统计查询-供应商排名--供应商画像
  // {
  //   path: 'supPortrait',
  //   name: 'supPortrait',
  //   meta: {
  //     title: '供应商画像',
  //     hidden: true
  //   },
  //   component: () => import('@/pages/supplierModule/statisticalQueryMenu/supRankingList/supPortrait')
  // },
  // 供应商管理-供应商审批-评级审批
  {
    path: 'supGradeApprovalDetail',
    name: 'supGradeApprovalDetail',
    meta: {
      title: '评级审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supGradeApprovalList/supGradeApprovalDetail');
    }
  }, // 供应商管理-供应商审批-查看详情
  {
    path: 'supGradeApproval',
    name: 'supGradeApproval',
    meta: {
      title: '查看详情',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supGradeApprovalList/supGradeApproval');
    }
  }, // 供应商管理-供应商审批-黑名单审批
  {
    path: 'supBlackApprovalList',
    name: 'supBlackApprovalList',
    meta: {
      title: '黑名单审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supBlackApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supBlackApprovalList/supBlackApprovalList');
    }
  }, // 供应商管理-供应商审批-黑名单审批
  {
    path: 'supBlackApproval',
    name: 'supBlackApproval',
    meta: {
      title: '黑名单审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supBlackApprovalList/supBlackApproval');
    }
  }, // 供应商管理-供应商审批-黑名单审批-查看详情
  {
    path: 'supBlackApprovalDetail',
    name: 'supBlackApprovalDetail',
    meta: {
      title: '黑名单审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supBlackApprovalList/supBlackApprovalDetail');
    }
  }, // 供应商管理-评级管理-评级上报-查看审批情况
  {
    path: 'supRatingSituation',
    name: 'supRatingSituation',
    meta: {
      title: '查看审批情况',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supRatingReportList/supRatingSituation');
    }
  }, // 供应商管理-评级管理-评级上报-定级申请
  {
    path: 'supGradingDetail',
    name: 'supGradingDetail',
    meta: {
      title: '定级申请',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/ratingManagementMenu/supGradingManage/supGradingDetail');
    }
  }, // 供应商管理-供应商审批-失信行为申诉审批
  {
    path: 'supDishonestAppealApproveList',
    name: 'supDishonestAppealApproveList',
    meta: {
      title: '失信行为申诉审批',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['supDishonestAppealApproveList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supDishonestAppealApproveList/supDishonestAppealApproveList');
    }
  }, // 供应商管理-供应商审批-失信行为申诉审批详情页
  {
    path: 'supDishonestAppealApproveDetail',
    name: 'supDishonestAppealApproveDetail',
    meta: {
      title: '失信行为申诉审批',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/supDishonestAppealApproveList/supDishonestAppealApproveDetail');
    }
  }, // 供应商管理（供应商侧）-店铺管理-店铺管理
  {
    path: 'storeManageList',
    name: 'storeManageList',
    meta: {
      title: '店铺管理',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['storeManageList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supStoreManageMenu/storeManage/storeManageList.vue');
    }
  }, // 供应商管理（供应商侧）-店铺管理-店铺推广
  {
    path: 'storePromotionList',
    name: 'storePromotionList',
    meta: {
      title: '店铺推广',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['storePromotionList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supStoreManageMenu/storePromotion/storePromotionList.vue');
    }
  }, // 供应商管理（供应商侧）-店铺管理-店铺审批
  {
    path: 'storeApprovalList',
    name: 'storeApprovalList',
    meta: {
      title: '店铺审批',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['storeApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supStoreApprovalMenu/storeApproval/storeApprovalList.vue');
    }
  }, // 供应商管理（供应商侧）-店铺管理-店铺详情
  {
    path: 'storeDetail',
    name: 'storeDetail',
    meta: {
      title: '店铺审批',
      menuTab: '',
      hidden: true
    },
    component: function component() {
      return import('@/pages/supplierModule/supStoreApprovalMenu/storeApproval/storeDetail.vue');
    }
  }, // 供应商管理（供应商侧）-店铺管理-店铺冻结审批
  {
    path: 'storeFrozenApprovalList',
    name: 'storeFrozenApprovalList',
    meta: {
      title: '店铺冻结审批',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['storeFrozenApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supStoreApprovalMenu/storeFrozenApproval/storeFrozenApprovalList.vue');
    }
  }, // 供应商管理（供应商侧）-店铺管理-店铺解冻审批
  {
    path: 'storeThawApprovalList',
    name: 'storeThawApprovalList',
    meta: {
      title: '店铺解冻审批',
      menuTab: '',
      cache: true,
      isCheckMenu: true,
      belongMenus: ['storeThawApprovalList']
    },
    component: function component() {
      return import('@/pages/supplierModule/supStoreApprovalMenu/storeThawApproval/storeThawApprovalList.vue');
    }
  }, // 1menu供应商管理-YJL / 2menu统计查询 / 3menu供应商排名
  // {
  //   path: 'supRankingList',
  //   name: 'supRankingList',
  //   meta: {
  //     title: '供应商排名',
  //     cache: true
  //   },
  //   component: () => import('@/pages/supplierModule/statisticalQueryMenu/supRankingList/supRankingList')
  // },
  // // 1menu供应商管理-YJL / 2menu统计查询 / 3menu供应商排名 / 供应商画像-
  // {
  //   path: 'supPortrait',
  //   name: 'supPortrait',
  //   meta: {
  //     title: '供应商画像',
  //     hidden: true
  //   },
  //   component: () => import('@/pages/supplierModule/statisticalQueryMenu/supRankingList/supPortrait')
  // }
  // 1menu供应商管理-YJL / 2menu统计查询 / 3menu供应商排名 / 供应商信息表
  // {
  //   path: 'supRankingDetail',
  //   name: 'supRankingDetail',
  //   meta: {
  //     title: '供应商信息表',
  //     hidden: true
  //   },
  //   component: () => import('@/pages/supplierModule/statisticalQueryMenu/supRankingList/supRankingDetail')
  // },
  // 1menu供应商管理-YJL / 2menu统计查询 / 3menu供应商名录
  // {
  //   path: 'supNameList',
  //   name: 'supNameList',
  //   meta: {
  //     title: '供应商名录',
  //     cache: true
  //   },
  //   component: () => import('@/pages/supplierModule/statisticalQueryMenu/supNameList/supNameList')
  // },
  // 1menu供应商管理-YJL / 2menu统计查询 / 3menu供应商画像-区域分布
  // {
  //   path: 'supImgList',
  //   name: 'supImgList',
  //   meta: {
  //     title: '供应商画像-区域分布',
  //     cache: true
  //   },
  //   component: () => import('@/pages/supplierModule/statisticalQueryMenu/supImgList/supImgList')
  // }
  // 供应商管理-供应商管理-供应商管理
  {
    path: 'supManagement',
    name: 'supManagement',
    meta: {
      title: '供应商管理'
    },
    component: function component() {
      return import('@/pages/supplierModule/supManagementMenu/supManagement/supManagement.vue');
    }
  }, // 供应商管理-供应商管理-供应商管理-供应商创建
  {
    path: 'supCreate',
    name: 'supCreate',
    meta: {
      title: '供应商创建'
    },
    component: function component() {
      return import('@/pages/supplierModule/supManagementMenu/supManagement/supCreate.vue');
    }
  }, // 供应商管理-供应商管理-供应商管理-供应商更新
  {
    path: 'supEdit',
    name: 'supEdit',
    meta: {
      title: '供应商编辑'
    },
    component: function component() {
      return import('@/pages/supplierModule/supManagementMenu/supManagement/supEdit.vue');
    }
  }, // 供应商管理-供应商管理-供应商管理-供应商详情
  {
    path: 'supDetail',
    name: 'supDetail',
    meta: {
      title: '供应商详情'
    },
    component: function component() {
      return import('@/pages/supplierModule/supManagementMenu/supManagement/supDetail.vue');
    }
  }, // 供应商管理(卖家侧)-我要准入
  {
    path: 'supAdmitted',
    name: 'supAdmitted',
    meta: {
      title: '我要准入'
    },
    component: function component() {
      return import('@/pages/supplierModule/supManagementMenu/newSupManagement/supAdmitted.vue');
    }
  }, // 供应商管理(卖家侧)-企业信息
  {
    path: 'supEnterpriseInfo',
    name: 'supEnterpriseInfo',
    meta: {
      title: '我的企业信息'
    },
    component: function component() {
      return import('@/pages/supplierModule/supManagementMenu/newSupManagement/supEnterpriseInfo.vue');
    }
  }, // 供应商管理-供应商审批-供应商准入审批
  {
    path: 'newSupAdmittanceApprovalList',
    name: 'newSupAdmittanceApprovalList',
    meta: {
      title: '供应商准入审批'
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/newSupAdmittanceApprovalList/supAdmittanceApprovalList.vue');
    }
  }, // 供应商管理-供应商审批-供应商准入审批-审批
  {
    path: 'newSupApproved',
    name: 'newSupApproved',
    meta: {
      title: '供应商准入审批'
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/newSupAdmittanceApprovalList/supApproved.vue');
    }
  }, // 供应商管理-供应商审批-信息变更审批
  {
    path: 'newSupInfoChangeApprovalList',
    name: 'newSupInfoChangeApprovalList',
    meta: {
      title: '信息变更审批'
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/newSupInfoChangeApprovalList/supInfoChangeApprovalList.vue');
    }
  }, // 供应商管理-供应商审批-信息变更审批-审批
  {
    path: 'newSupChangeApproved',
    name: 'newSupChangeApproved',
    meta: {
      title: '信息变更审批'
    },
    component: function component() {
      return import('@/pages/supplierModule/supApprovalMenu/newSupInfoChangeApprovalList/supChangeApproved.vue');
    }
  }]
};